<template>
  <v-menu v-model="menu"
          :disabled="disabled"
          :open-on-hover="openonhover"
          :min-width="width"
          :max-width="width"
          :close-on-content-click="closeonclick"
          :offset-y="offsety"
          :offset-x="offsetx"
          :top="top"
          :left="left"
          :bottom="bottom"
          :right="right"
          :nudge-top="nudgetop"
          :nudge-left="nudgeleft"
          :nudge-bottom="nudgebottom"
          :nudge-right="nudgeright"
          :open-delay="delay">

    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs"
           v-on="on"
           style="max-width: 100%"
           @click="$emit('activatorclick')"
           @mouseover="hover= true"
           @mouseleave="hover= false">
        <slot name="menu-activator"></slot>
      </div>
    </template>

    <v-card class="squere-corners">
      <slot name="menu-content"></slot>
    </v-card>
  </v-menu>
</template>


<script>
export default {
  name: "HoverMenu",
  model: {
    prop: "menustate",
    event: "change",
  },
  props: {
    hoverstate: Boolean,
    width: String,
    lockcloseonleave: Boolean,
    closeonclick: Boolean,
    direction: String,
    disabled: Boolean,
    nudgeamount: Number,
    delay: Number,
  },
  components: {},
  mixins: [],

  data() {
    return {
      menu: null,
      hover: false,
      openonhover: true,
    };
  },

  mounted() {},

  methods: {
    changehover(val) {
      this.hover = val;
    },
  },

  computed: {
    top() {
      return this.direction && this.direction === "top";
    },
    left() {
      return this.direction && this.direction === "left";
    },
    bottom() {
      return !this.direction || this.direction === "bottom";
    },
    right() {
      return this.direction && this.direction === "right";
    },

    offsetx() {
      if (this.left || this.right) {
        return true;
      } else {
        return false;
      }
    },
    offsety() {
      if (this.top || this.bottom) {
        return true;
      } else {
        return false;
      }
    },

    nudgeval() {
      return this.nudgeamount != undefined ? this.nudgeamount : 0;
    },
    nudgetop() {
      return this.top ? this.nudgeval : 0;
    },
    nudgeleft() {
      return this.left ? this.nudgeval : 0;
    },
    nudgebottom() {
      return this.bottom ? this.nudgeval : 0;
    },
    nudgeright() {
      return this.right ? this.nudgeval : 0;
    },
  },

  watch: {
    menu: function (val) {
      this.$emit("change", val);
    },

    hover: function (val) {
      if (val && this.lockcloseonleave) {
        this.openonhover = false;
      }
      this.$emit("Hover", val);
    },
  },
};
</script>


<style lang="scss" scoped>
.v-menu__content,
.squere-corners {
  border-radius: 0px !important;
  border-bottom-left-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
  z-index: 2500 !important;
}
/* //attempt at litte triangle on bottom (like a tooltip or speetchbubble)
.v-menu__content:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: solid 10px #e15915;
  border-left: solid 10px transparent;
  border-right: solid 10px transparent;
}
*/
</style>